import React, { useEffect, useState } from 'react';
import Footer from './Footer';
import Header from './Header';
import Layout from './Layout';

// Fallback logo to use when a site's logo isn't available
const FALLBACK_LOGO = 'https://cryptologos.cc/logos/ethereum-eth-logo.png';

const NewsAndArticles = () => {
  const [headingStyle, setHeadingStyle] = useState({ fontSize: '32px' });

  useEffect(() => {
    window.scrollTo(0, 0);
    const updateHeadingSize = () => {
      const width = window.innerWidth;
      if (width < 480) {
        setHeadingStyle({ fontSize: '20px' });
      } else if (width < 768) {
        setHeadingStyle({ fontSize: '24px' });
      } else if (width < 1024) {
        setHeadingStyle({ fontSize: '28px' });
      } else {
        setHeadingStyle({ fontSize: '32px' });
      }
    };
    updateHeadingSize();
    window.addEventListener('resize', updateHeadingSize);
    return () => window.removeEventListener('resize', updateHeadingSize);
  }, []);

  const articles = [
      {
      url: "https://londoninsider.co.uk/the-rizzentials-program-is-a-new-way-to-reward-telecom-subscribers-that-changes-how-they-utilize-their-mobile-services/",
      title: "RZTO Telecom Token Powers Rizzentials Program Launch with Zoyili.com Partnership",
      site: "LONDON INSIDER",
      logo: "https://londoninsider.co.uk/wp-content/uploads/2023/10/li-2.png"
     },
     {
      url: "https://www.cryptointelligence.co.uk/telecom-token-rzto-and-rizz-wireless-the-future-of-mobile-rewards-is-here/",
      title: "Telecom Token RZTO and Rizz Wireless - The Future of Mobile Rewards",
      site: "CryptoIntelligence",
      logo: "https://logo.clearbit.com/cryptointelligence.co.uk?size=32"
    },
    {
      url: "https://cryptodaily.co.uk/2025/05/rzto-token-set-to-push-the-boundaries-of-telecom-with-web3-integration",
      title: "RZTO Token Set to Push the Boundaries of Telecom with Web3 Integration",
      site: "CryptoDaily",
      logo: "https://logo.clearbit.com/cryptodaily.co.uk?size=32"
    },
    {
      url: "https://financefeeds.com/10-cryptocurrency-projects-for-investors-in-2025/",
      title: "10 Cryptocurrency Projects for Investors in 2025",
      site: "FinanceFeeds",
      logo: "https://logo.clearbit.com/financefeeds.com?size=32"
    },
    {
      url: "https://techbullion.com/solana-based-tokens-to-invest-in-2025/",
      title: "Solana-Based Tokens to Invest in 2025",
      site: "TechBullion",
      logo: "https://logo.clearbit.com/techbullion.com?size=32"
    },
    {
      url: "https://captainaltcoin.com/5-crypto-travel-projects-for-lifestyle-in-2025/",
      title: "5 Crypto Travel Projects for Lifestyle in 2025",
      site: "CaptainAltcoin",
      logo: "https://logo.clearbit.com/captainaltcoin.com?size=32"
    },
    {
      url: "https://coinpaper.com/9282/7-utility-tokens-to-invest-in-2025-the-first-one-is-going-to-surprise-you",
      title: "7 Utility Tokens to Invest in 2025",
      site: "Coinpaper",
      logo: "https://logo.clearbit.com/coinpaper.com?size=32"
    },
    {
      url: "https://coinchapter.com/5-crypto-projects-with-real-world-utility-in-2025/",
      title: "5 Crypto Projects with Real-World Utility in 2025",
      site: "CoinChapter",
      logo: "https://logo.clearbit.com/coinchapter.com?size=32"
    },
    {
      url: "https://coincu.com/339773-9-innovative-crypto-projects-of-2025/",
      title: "9 Innovative Crypto Projects of 2025",
      site: "CoinCu",
      logo: "https://logo.clearbit.com/coincu.com?size=32"
    },
    {
      url: "https://bitcoinworld.co.in/8-crypto-tokens-for-passive-income-in-2025/",
      title: "8 Crypto Tokens for Passive Income in 2025",
      site: "BitcoinWorld",
      logo: "https://logo.clearbit.com/bitcoinworld.co.in?size=32"
    },
    {
      url: "https://startupfortune.com/best-crypto-tokens-to-buy-in-2025/",
      title: "Best Crypto Tokens to Buy in 2025",
      site: "StartupFortune",
      logo: "https://logo.clearbit.com/startupfortune.com?size=32"
    },
    {
      url: "https://coinmarketcap.com/community/articles/683507662389d556617635c0/",
      title: "Community Article on CoinMarketCap",
      site: "CoinMarketCap",
      logo: "https://logo.clearbit.com/coinmarketcap.com?size=32"
    },
     {
      url: "https://coinpedia.org/information/5-utility-blockchain-tokens-revolutionizing-telecom-in-2025/",
      title: "5 Utility Blockchain Tokens Revolutionizing Telecom in 2025",
      site: "Coinpedia",
      logo: "https://image.coinpedia.org/static/common/coinpedia-logo.svg"
    }
   
  ];

  return (
    <>
      <Layout>
        <div style={styles.container}>
          <h1 style={{...styles.heading, ...headingStyle}}>News & Articles</h1>
          {/* <p style={styles.subheading}>Featured in top crypto and tech publications</p> */}
          
          <div style={styles.grid}>
            {articles.map((article, index) => (
              <a href={article.url} target="_blank" rel="noopener noreferrer" key={index} style={styles.card}>
                <div style={styles.cardContent}>
                  <div style={styles.logoContainer}>
                    <img 
                      src={article.logo} 
                      alt={article.site} 
                      style={styles.logo}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = FALLBACK_LOGO;
                      }}
                    />
                    <span style={styles.siteName}>{article.site}</span>
                  </div>
                  <h3 style={styles.articleTitle}>{article.title}</h3>
                  <div style={styles.readMore}>
                    Read Article <span style={styles.arrow}>→</span>
                  </div>
                </div>
                <div style={styles.glow}></div>
              </a>
            ))}
          </div>
        </div>
      </Layout>
    </>
  );
};

const styles = {
  container: {
    fontFamily: "'Inter', sans-serif",
    lineHeight: '1.6',
    padding: '20px',
    color: '#fff',
    margin: '30px auto',
    maxWidth: '1200px',
    width: '100%',
    boxSizing: 'border-box',
    background: '#22c9ff',
    borderRadius: '16px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
  },
  heading: {
    color: 'white',
    textAlign: 'center',
    marginBottom: '10px',
    fontWeight: '800',
    fontSize: '2.5rem',
    textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
  },
  subheading: {
    color: 'rgba(255, 255, 255, 0.9)',
    textAlign: 'center',
    marginBottom: '40px',
    fontSize: '18px',
    fontWeight: '500',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: '25px',
    padding: '20px',
  },
  card: {
    position: 'relative',
    background: 'rgba(255, 255, 255, 0.95)',
    borderRadius: '12px',
    padding: '25px',
    transition: 'all 0.3s ease',
    overflow: 'hidden',
    border: 'none',
    textDecoration: 'none',
    color: 'inherit',
    zIndex: '1',
    ':hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 15px 30px rgba(0, 0, 0, 0.2)',
    },
    ':hover $glow': {
      opacity: '0.8',
    },
  },
  cardContent: {
    position: 'relative',
    zIndex: '2',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '15px',
    padding: '8px',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderRadius: '8px',
    width: 'fit-content',
  },
  logo: {
    width: '40px',
    height: '40px',
    borderRadius: '8px',
    marginRight: '12px',
    objectFit: 'contain',
    backgroundColor: 'white',
    padding: '4px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  },
  siteName: {
    color: '#333',
    fontSize: '16px',
    fontWeight: '700',
  },
  articleTitle: {
    color: '#222',
    fontSize: '18px',
    margin: '0 0 15px 0',
    flexGrow: '1',
    fontWeight: '600',
    lineHeight: '1.4',
  },
  readMore: {
    color: '#3a47d5',
    fontSize: '14px',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    marginTop: 'auto',
  },
  arrow: {
    marginLeft: '8px',
    transition: 'transform 0.3s ease',
    color: '#22c9ff',
  },
  glow: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: '0',
    left: '0',
    background: 'radial-gradient(circle at center, rgba(58, 71, 213, 0.15) 0%, rgba(0, 0, 0, 0) 70%)',
    opacity: '0',
    transition: 'opacity 0.3s ease',
    zIndex: '1',
  },
};

export default NewsAndArticles;